exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".show-pipeline-template-json-modal__copy {\n  margin-bottom: 5px;\n}\n.show-pipeline-template-json-modal__save-error {\n  color: var(--color-danger);\n}\n", ""]);

